var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeevLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 36,
    viewBox: "0 0 47 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.190801 32.8082L27.4198 1.18434C28.2064 0.215024 30.1427 -1.06932 31.5949 1.54783L35.2254 16.6328L43.5756 11.5439C44.7253 11.0592 46.9157 10.7805 46.4801 13.5431L42.1234 27.9011C41.5184 29.2339 39.7999 31.0998 37.7668 27.9011L35.2254 16.6328L2.9137 35.8979C1.64301 36.2008 -0.680527 36.007 0.190801 32.8082Z",
    fill: "url(#paint0_linear_816_64252)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_816_64252",
    x1: 5.80885,
    y1: 31.2604,
    x2: 34.1963,
    y2: -0.64354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D1DF0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeevLogo);
export default __webpack_public_path__ + "static/media/neev_logo.8a9f631a9038045ab353cd94fcfbfdb4.svg";
export { ForwardRef as ReactComponent };